import { useEffect } from "react";
import { PALETTES, FONT_PAIRS } from "@/lib/design";

/**
 * Load Google Fonts for the chosen font_pair dynamically and inject CSS vars.
 * This makes each public site feel like its own brand.
 */
export function useSiteTheme(site) {
  const palette = PALETTES[site?.palette] || PALETTES.newsprint;
  const fp = FONT_PAIRS[site?.font_pair] || FONT_PAIRS.pair_a;

  useEffect(() => {
    if (!site) return;
    // load font css (fontshare or google fonts)
    const id = `font-${site.font_pair}`;
    if (!document.getElementById(id)) {
      const link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href = `https://fonts.googleapis.com/css2?family=${fp.googleFonts}&display=swap`;
      document.head.appendChild(link);
    }
    document.documentElement.style.setProperty("--site-bg", palette.bg);
    document.documentElement.style.setProperty("--site-surface", palette.surface);
    document.documentElement.style.setProperty("--site-text", palette.text);
    document.documentElement.style.setProperty("--site-muted", palette.muted);
    document.documentElement.style.setProperty("--site-accent", palette.accent);
    document.documentElement.style.setProperty("--site-rule", palette.rule);
    document.documentElement.style.setProperty("--site-display", fp.display);
    document.documentElement.style.setProperty("--site-body", fp.body);
    document.title = site.name + (site.tagline ? " — " + site.tagline : "");
    return () => {
      // do not strip vars / fonts — they are inert if user navigates back to admin
    };
  }, [site, palette, fp]);

  return { palette, fp };
}
